import styled from 'styled-components';

export const PreviewDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    background-color: white;
`;

export const CenterPanelDiv = styled.div`
    margin: 70px;
    height: calc(100% - 50px);
`;

export const DivPadding = styled.div`
    padding: 10px;
`;

export const Text = styled.p`
    font-size: 14px;
    font-style: italic;
    padding: 10px;
`;

export const TextBold = styled.span`
    font-weight: bold;
`;

export const LoadingImg = styled.img`
    display: block;
    margin: 50px auto 10px;
`;

export const LoadingText = styled.p`
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.neutral900};
`;

export const ViewIcon = styled.div`
    font-size: 20px;
    color: ${({ isSelected, theme }) => (isSelected ? theme.colors.primary300 : theme.colors.neutral900)};
`;

export const ViewIconSpacer = styled.div`
    border: ${({ theme }) => `1px solid ${theme.colors.neutral000}`};
    height: 31px;
    margin-bottom: 18px;
`;

export const LeftPanelOuterDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 260px;
    height: calc(100vh - 76px);
    margin-top: 13px;
    overflow-y: auto;
    overflow-x: hidden;
`;

/* PreviewLeftPanel */

export const LeftPanelDiv = styled.div`
    width: 270px;
    height: 100%;
    background-color: white;
    position: relative;
    user-select: none;
`;

export const LeftPanelInnerDiv = styled.div`
    width: 220px;
    margin: 0px 13px 13px 20px;
`;

export const LeftPanelHeader = styled.h2`
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 2px 0 12px 6px;
`;

export const WarningToggleDiv = styled.div`
    display: block;
    padding: 6px 0 6px 6px;
    height: 30px;
`;

export const WarningToggleTextContainer = styled.div`
    float: left;
`;

export const ToggleDiv = styled.div`
    float: right;
    margin-top: -3px;
    margin-right: 25px;
`;
export const WarningToggleText = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 13px;
    font-weight: 400;
    margin-right: 4px;
`;

export const CustomFontsWarningContainer = styled.div`
    width: 100%;
    height: 120px;
    position: relative;
    margin: 8px 0 0 0;
`;

export const CustomFontsWarningTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 0 36px;
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 13px;
    line-height: 24px;
`;

export const CustomFontsLink = styled.a`
    color: ${({ theme }) => theme.colors.primary300};
`;

export const RadioListContainer = styled.div`
    height: 52px;
    margin: 8px;
    color: ${({ theme }) => theme.colors.neutral900};
`;

export const SizeTrackerContainer = styled.div`
    width: 100%;
    height: 40px;
    position: relative;
    margin: 4px 0;
    color: ${({ theme }) => theme.colors.neutral900};
`;

export const PreviewWidthContainer = styled.div`
    width: 84px;
    position: absolute;
    left: 39px;
    top: 0px;
    background: transparent;
    display: flex;
    align-items: center;
    margin-top: 10px;
    text-align: center;
`;

export const Button = styled.div`
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 5px 10px;
    outline: none;
    cursor: pointer;
`;

export const PreviewIcon = styled.div`
    display: inline-block;
    width: 20px;
    height: 20px;
    padding: 5px;
    margin: 10px 5px;
    outline: none;
    cursor: pointer;
    :hover {
        background: ${({ theme }) => theme.colors.pastelPrimary300};
    }
`;

export const LoadingDiv = styled.div`
    width: calc(100% - 310px);
    height: calc(100% - 78px);
    border: ${({ theme }) => `1px solid ${theme.colors.neutral100}`};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    background-color: ${({ theme }) => theme.colors.neutral000};
    top: 64px;
    right: 40px;
    position: absolute;
`;

export const Preview = styled.div`
    position: absolute;
    top: 64px;
    right: 40px;
    width: calc(100% - 308px);
    height: calc(100% - 60px);
    margin: 8px auto;
`;

export const InnerDiv = styled.div`
    padding: 0;
    width: 800px;
    margin: 8px auto;
    box-sizing: border-box;
    height: calc(100% - 65px);
`;
